import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/styles/utils/variables.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/styles/_normalize.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/styles/body.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/styles/gallery.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/button/button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/link-button/link-button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/rich-text/rich-text.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/video/video.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/checkbox/checkbox.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/icon-tooltip/icon-tooltip.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/info-popup/info-popup.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/dropdown/dropdown.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/loading-spinner/loading-spinner.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/typeahead/typeahead.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/toggle-button/toggle-button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/accordion/accordion.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/preview-banner/preview-banner.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/hero/hero.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/styles/checkbox-group/checkbox-group.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/component-list/component-list.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/cta/cta.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/card/card.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/card-set/card-set.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/styles/partials/breakpoints.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/media-gallery/media-gallery.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/map/map.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/carousel/carousel.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/comparison-carousel/comparison-carousel.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/advert-banner/advert-banner.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/cta-card-set/cta-card-set.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/cta-card/cta-card.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/cta-hero/cta-hero.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/testimonials-card-set/testimonial-card-set.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/testimonials-card/testimonial-card.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/search-bar/search-bar.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/toggle-button-group/toggle-button-group.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/summary-degree/summary-degree.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/summary-degree-list/summary-degree-list.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/search-sort/search-sort.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/key-information/key-information.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-details/course-details.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/tabs/tabs.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-requirements/course-requirements.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Accordion/Accordion.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Alert/Alert.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/AssistiveText/AssistiveText.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Button/Button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Checkbox/Checkbox.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/ValidationMessage/ValidationMessage.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/legacy/image.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/slick-carousel/slick/slick-theme.css");
;
import(/* webpackMode: "eager", webpackExports: ["ContentfulPreviewProvider"] */ "/app/src/app/_components/atoms/contentful-preview-provider/contentful-preview-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_providers/MicrositeOrderedPageProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/_helpers/branding.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/CheckboxGroup/CheckboxGroup.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/DatePicker/DateInput/DateInput.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/DatePicker/DatePicker.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Dropdown/Dropdown.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Dropdown/CustomSelect/CustomSelect.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/shared/DropdownOptionsList/DropdownOptionsList.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/shared/DropdownOptionsList/DropdownOptionsListItem/DropdownOptionsListItem.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/DropdownSearch/DropdownSearch.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/DropdownSearch/CustomSearchSelect/CustomSearchSelect.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/DropdownSearch/SearchInput/SearchInput.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/DropdownSearch/SelectedOption/SelectedOption.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Header/Header.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/LinkButton/LinkButton.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/TextInput/TextInput.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Toggle/Toggle.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Header/SignIn/SignIn.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/Header/TextLink/TextLink.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/RadioButton/RadioButton.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/RadioButtonGroup/RadioButtonGroup.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into/react-components/src/components/CopyLink/CopyLink.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-dates/course-dates.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-progression/course-progression.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-progressions-list/course-progressions-list.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-modules/course-modules.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-modules-us/course-modules-us.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-modules-uk/course-modules-uk-au.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-fees-and-pricing/course-fees-and-pricing.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/course-list/course-list.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/sidebar-navigation/sidebar-navigation.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/top-menu/top-menu.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/profile-button/profile-button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/language-switcher/language-switcher.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/mobile-navigation/mobile-navigation.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/dropdown-toggle-button/dropdown-toggle-button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/desktop-navigation/navigation.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/university-grid-page/university-grid-page-template.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/course-type-badge/course-type-badge.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/country-pill/country-pill.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/university-card/university-card.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/universities-filter/universities-filter.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/course-page/course-page-template.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/homepage-hero/homepage-hero.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/promo-card-row/promo-card-row.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/atoms/promo-card/promo-card.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/university-select-bar/university-select-bar.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/courses-page/courses-page.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/summary-page/summary-page-template.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/summary-details/summary-details.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/student-type-selector/student-type-selector.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/choice-degree-finder/choice-degree-finder.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/choice-degree-finder-list/choice-degree-finder-list.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/header/header.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/footer/footer.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/organisms/summary-page-old/summary-page-template-old.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/summary-details-old/summary-details-old.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/summary-degree-list-old/summary-degree-list-old.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@into-discovery/browsewebshared/src/components/molecules/summary-degree-old/summary-degree-old.module.scss");
